import {createContext} from 'react'

import type {ProvisioningKind, RuntimeStatus} from '../types'

export const RuntimeStatusContext = createContext<RuntimeStatus | null>(null)
export const ProvisioningKindContext = createContext<ProvisioningKind | undefined>(undefined)
